import { PrimaryPaper } from "Components/Shared/PrimaryPaper";

import { CircularProgress } from "@mui/material";

import { Stack } from "@mui/material";
import {
  MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS,
  STEP_TO_ICON,
} from "Components/Hunter/Merchants/CompleteRegistration/steps";
import { Stepper } from "Components/Shared/Stepper/Stepper";
import { Resources, useResource } from "Translations/Resources";

const doNothing = () => {};

export const MerchantCompleteRegistrationPageSkeleton = () => {
  const { t } = useResource();

  const steps = MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS.map((id) => ({
    id,
    label: t(Resources.Hunter.Merchants.CompleteRegistration.Steps[id]),
    isCompleted: false,
    icon: STEP_TO_ICON[id],
  }));

  return (
    <Stack gap={2}>
      <Stepper steps={steps} onStepClick={doNothing} />
      <PrimaryPaper
        sx={{
          height: 525,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress sx={{ color: "grey.300" }} />
      </PrimaryPaper>
    </Stack>
  );
};
